import * as React from 'react'
import { memo } from 'react'
const SvgArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 36 9"
  >
    <path
      fill="#fff"
      d="M36 3.96 7.92 3.78C9 2.34 9.54 1.44 9.54 0 7.02 2.16 3.78 3.42 0 4.5 3.96 5.58 7.02 6.84 9.54 9a6.14 6.14 0 0 0-1.8-3.78L36 5.4Z"
    />
  </svg>
)
const Memo = memo(SvgArrowLeft)
export default Memo
